import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import {requireElement} from "../libs/Helpers";
import {swiperSetup} from "../libs/SwiperSetup";
import Swiper from "swiper";
import {SwiperOptions} from "swiper/types";

export default class SwiperSlider extends BaseModule {
    constructor(el: HTMLElement, factory: Factory) {
        super(el, factory, 'SwiperSlider');

        const swiperElement = requireElement(el, '.swiper');
        const swiperConfig: SwiperOptions = swiperSetup(swiperElement);
        const _ = new Swiper(swiperElement, swiperConfig);
    }
}

